export const sexes = {
    1: 'Hombre',
    2: 'Mujer',
    3: 'Otra Opción'
};